// Realistic sample data for PremierLab.ai MVP foundation
export const SAMPLE_PROJECTS = [
  {
    id: "p1",
    title: "The Operator's Playbook",
    type: "book",
    status: "designed",
    progress: 64,
    thumbnail: "https://images.unsplash.com/photo-1762365189058-7be5b07e038b?w=600&q=80",
    description: "Direct-response authority book for SaaS founders.",
    updated_at: "2026-02-01T10:00:00Z",
  },
  {
    id: "p2",
    title: "5-Day Cashflow Challenge Workbook",
    type: "workbook",
    status: "draft",
    progress: 22,
    thumbnail: "https://images.unsplash.com/photo-1590102426275-8d1c367070d3?w=600&q=80",
    description: "Companion workbook for live 5-day virtual challenge.",
    updated_at: "2026-02-04T14:00:00Z",
  },
  {
    id: "p3",
    title: "Q1 Investor Pitch Deck",
    type: "slides",
    status: "approved",
    progress: 89,
    thumbnail: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&q=80",
    description: "Series A storyline with proof stack.",
    updated_at: "2026-02-03T08:00:00Z",
  },
  {
    id: "p4",
    title: "Premium Webinar Flyer",
    type: "flyer",
    status: "live",
    progress: 100,
    thumbnail: "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?w=600&q=80",
    description: "High-conversion event promo with QR code.",
    updated_at: "2026-01-30T12:00:00Z",
  },
  {
    id: "p5",
    title: "Cart Close Email Campaign",
    type: "campaign",
    status: "scheduled",
    progress: 78,
    thumbnail: "https://images.unsplash.com/photo-1633409361618-c73427e4e206?w=600&q=80",
    description: "7-email cart close + 5-SMS reminder sequence.",
    updated_at: "2026-02-05T09:00:00Z",
  },
  {
    id: "p6",
    title: "Audiobook: Operator's Playbook",
    type: "audiobook",
    status: "draft",
    progress: 12,
    thumbnail: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=600&q=80",
    description: "Chapter-by-chapter audiobook narration.",
    updated_at: "2026-02-02T17:00:00Z",
  },
];

export const SAMPLE_TEMPLATES = [
  { id: "t1", name: "Dark Authority Webinar Deck", category: "slides", thumb: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500&q=80" },
  { id: "t2", name: "Premium SaaS Pitch Deck", category: "slides", thumb: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=500&q=80" },
  { id: "t3", name: "Workshop Workbook", category: "workbook", thumb: "https://images.unsplash.com/photo-1568667256549-094345857637?w=500&q=80" },
  { id: "t4", name: "Direct Response Book", category: "book", thumb: "https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=500&q=80" },
  { id: "t5", name: "Lead Magnet Cover", category: "cover", thumb: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=500&q=80" },
  { id: "t6", name: "Event Flyer Premium", category: "flyer", thumb: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=500&q=80" },
  { id: "t7", name: "Cart Close Sequence", category: "campaign", thumb: "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=500&q=80" },
  { id: "t8", name: "Founder Story Deck", category: "slides", thumb: "https://images.unsplash.com/photo-1542744095-291d1f67b221?w=500&q=80" },
];

export const SAMPLE_CONTACTS = [
  { id: "c1", name: "Aaron Mitchell", email: "aaron@growthco.io", tags: ["buyer", "webinar-1"], lastActivity: "2026-02-04" },
  { id: "c2", name: "Priya Shah", email: "priya@authorhouse.com", tags: ["lead", "challenge"], lastActivity: "2026-02-03" },
  { id: "c3", name: "Marcus Lee", email: "marcus@scaleforge.com", tags: ["client", "vip"], lastActivity: "2026-02-05" },
  { id: "c4", name: "Helena Cruz", email: "helena@bookcraft.io", tags: ["lead"], lastActivity: "2026-01-28" },
  { id: "c5", name: "Devon Brooks", email: "devon@launchstack.com", tags: ["buyer"], lastActivity: "2026-02-02" },
];

export const SAMPLE_INTEGRATIONS = [
  { id: "openai", name: "OpenAI / GPT", category: "AI Models", state: "connected", desc: "GPT-5.2 for slides, copy, automations." },
  { id: "anthropic", name: "Anthropic / Claude", category: "AI Models", state: "connected", desc: "Claude Sonnet for long-form writing." },
  { id: "gemini", name: "Google Gemini", category: "AI Models", state: "connected", desc: "Gemini for visual analysis & files." },
  { id: "nano-banana", name: "Nano Banana", category: "AI Models", state: "needs_attention", desc: "Image generation provider slot." },
  { id: "elevenlabs", name: "ElevenLabs", category: "AI Models", state: "pending_verification", desc: "Voice & audiobook narration." },
  { id: "whisper", name: "Whisper Transcription", category: "AI Models", state: "connected", desc: "Audio → text transcription." },
  { id: "mailgun", name: "Mailgun", category: "Email", state: "not_connected", desc: "Transactional & broadcast email." },
  { id: "sendgrid", name: "SendGrid", category: "Email", state: "connected", desc: "Marketing email at scale." },
  { id: "ses", name: "Amazon SES", category: "Email", state: "not_connected", desc: "Cost-effective AWS email." },
  { id: "resend", name: "Resend", category: "Email", state: "not_connected", desc: "Modern developer email." },
  { id: "twilio", name: "Twilio", category: "SMS", state: "connected", desc: "SMS delivery, OTP, broadcasts." },
  { id: "telnyx", name: "Telnyx", category: "SMS", state: "not_connected", desc: "Direct carrier SMS." },
  { id: "stripe", name: "Stripe", category: "Payments", state: "connected", desc: "Payments, subscriptions, billing." },
  { id: "whop", name: "Whop", category: "Payments", state: "not_connected", desc: "Digital product checkout." },
  { id: "ghl", name: "GoHighLevel", category: "CRM/Marketing", state: "usage_limit_reached", desc: "All-in-one CRM." },
  { id: "hubspot", name: "HubSpot", category: "CRM/Marketing", state: "not_connected", desc: "CRM and marketing hub." },
  { id: "zoom", name: "Zoom", category: "CRM/Marketing", state: "connected", desc: "Webinars and meetings." },
  { id: "calendly", name: "Calendly", category: "CRM/Marketing", state: "not_connected", desc: "Meeting scheduling." },
  { id: "gdrive", name: "Google Drive", category: "Storage", state: "connected", desc: "Asset & export storage." },
  { id: "dropbox", name: "Dropbox", category: "Storage", state: "not_connected", desc: "File sync & sharing." },
  { id: "s3", name: "AWS S3", category: "Storage", state: "connected", desc: "Object storage backbone." },
  { id: "r2", name: "Cloudflare R2", category: "Storage", state: "not_connected", desc: "Egress-free object storage." },
  { id: "zapier", name: "Zapier", category: "Automation", state: "connected", desc: "Connect 6,000+ apps." },
  { id: "make", name: "Make", category: "Automation", state: "not_connected", desc: "Visual automation builder." },
  { id: "n8n", name: "n8n", category: "Automation", state: "not_connected", desc: "Self-host workflows." },
  { id: "webhooks", name: "Webhooks", category: "Automation", state: "connected", desc: "Send and receive events." },
  { id: "kdp", name: "KDP Export", category: "Export", state: "connected", desc: "Amazon KDP package builder." },
  { id: "epub", name: "EPUB", category: "Export", state: "error", desc: "Reflowable ebook format." },
];

export const STATE_LABEL = {
  not_connected: "Not Connected",
  connected: "Connected",
  needs_attention: "Needs Attention",
  usage_limit_reached: "Usage Limit Reached",
  error: "Error",
  pending_verification: "Pending Verification",
};

export const STATE_TONE = {
  not_connected: { dot: "bg-pl-muted", text: "text-pl-muted", border: "border-white/10" },
  connected: { dot: "bg-emerald-400", text: "text-emerald-300", border: "border-emerald-400/40" },
  needs_attention: { dot: "bg-yellow-400", text: "text-yellow-300", border: "border-yellow-400/40" },
  usage_limit_reached: { dot: "bg-orange-400", text: "text-orange-300", border: "border-orange-400/40" },
  error: { dot: "bg-rose-500", text: "text-rose-300", border: "border-rose-500/40" },
  pending_verification: { dot: "bg-[#27E6D1]", text: "text-[#27E6D1]", border: "border-[#27E6D1]/50" },
};

export const PIPELINE_STAGES = [
  { id: "draft", label: "Draft" },
  { id: "designed", label: "Designed" },
  { id: "approved", label: "Approved" },
  { id: "scheduled", label: "Scheduled" },
  { id: "live", label: "Live" },
  { id: "completed", label: "Completed" },
];

export const PROJECT_TYPES = [
  { id: "book", label: "Book" },
  { id: "ebook", label: "Ebook" },
  { id: "workbook", label: "Workbook" },
  { id: "slides", label: "Webinar Deck" },
  { id: "pitch", label: "Pitch Deck" },
  { id: "flyer", label: "Flyer" },
  { id: "cover", label: "Cover" },
  { id: "campaign", label: "Email Campaign" },
  { id: "sms", label: "SMS Sequence" },
  { id: "audiobook", label: "Audiobook" },
  { id: "automation", label: "Automation Flow" },
];

export const INPUT_TYPES = [
  { id: "prompt", label: "Prompt" },
  { id: "pdf", label: "PDF Upload" },
  { id: "docx", label: "DOCX Upload" },
  { id: "pptx", label: "PPTX Upload" },
  { id: "transcript", label: "Transcript" },
  { id: "paste", label: "Paste Text" },
  { id: "url", label: "Website URL" },
  { id: "youtube", label: "YouTube Transcript" },
  { id: "outline", label: "Course Outline" },
  { id: "voice", label: "Voice Note" },
];

export const COPILOT_MODES = [
  { id: "strategy", label: "Strategy" },
  { id: "writing", label: "Writing" },
  { id: "design", label: "Design" },
  { id: "layout", label: "Layout" },
  { id: "publishing", label: "Publishing" },
  { id: "automation", label: "Automation" },
  { id: "voice", label: "Voice" },
];

export const COPILOT_SUGGESTIONS = [
  "Create a webinar deck from this book",
  "Turn this transcript into a workbook",
  "Generate 7 reminder emails and 5 SMS messages",
  "Make this slide more premium",
  "Create a faded logo background",
  "Build a launch automation for this lead magnet",
];

export const PARAGRAPH_STYLES = [
  "Table of Contents", "TOC Level 1", "TOC Level 2",
  "Header Part", "Header Chapter", "Header 0",
  "Header 1", "Header 2", "Header 3",
  "Body Text", "Body Text Mini", "Body Text Semibold",
  "Body Text Indent", "Bullet Point", "Bullet Point Mini",
  "Bullet Point in Cells",
];

export const PROMPT_RULES = [
  { id: "pr1", lab: "BookLab", asset: "Chapter draft", model: "claude-sonnet-4-5", tone: "Authority", version: "v3" },
  { id: "pr2", lab: "BookLab", asset: "Title generator", model: "gpt-5.2", tone: "Direct response", version: "v2" },
  { id: "pr3", lab: "WorkbookLab", asset: "Reflection block", model: "claude-sonnet-4-5", tone: "Coaching", version: "v1" },
  { id: "pr4", lab: "SlideLab", asset: "Pitch deck copy", model: "gpt-5.2", tone: "Investor", version: "v4" },
  { id: "pr5", lab: "FlyerLab", asset: "Headline + CTA", model: "gpt-5.2", tone: "Bold marketing", version: "v2" },
  { id: "pr6", lab: "BrandLab", asset: "Voice & tone", model: "claude-sonnet-4-5", tone: "Premium", version: "v1" },
];

// --- New: Agent AI connectors (user-facing) ---
export const AGENT_CONNECTIONS = [
  { id: "claude", name: "Claude", desc: "Anthropic Claude — long-form writing, strategy, reasoning.", state: "connected", connector: "agent" },
  { id: "claude-code", name: "Claude Code", desc: "Claude Code — code and content workflows from a terminal.", state: "not_connected", connector: "agent" },
  { id: "cursor", name: "Cursor", desc: "AI-first IDE — connect PremierLab as a tool inside Cursor.", state: "not_connected", connector: "agent" },
  { id: "codex", name: "Codex", desc: "Codex agent runtime — multi-step content + code tasks.", state: "not_connected", connector: "agent" },
  { id: "openclaw", name: "OpenClaw", desc: "OpenClaw agent — open agent framework with tool calls.", state: "needs_attention", connector: "agent" },
  { id: "hermes", name: "Hermes", desc: "Hermes agent — research and synthesis.", state: "not_connected", connector: "agent" },
  { id: "nemoclaw", name: "NemoClaw", desc: "NemoClaw agent — autonomous creative ops.", state: "not_connected", connector: "agent" },
  { id: "mcp", name: "MCP Connector", desc: "Model Context Protocol endpoint for agent tools.", state: "connected", connector: "mcp" },
  { id: "cli", name: "CLI Connector", desc: "Authenticated CLI access to PremierLab APIs.", state: "not_connected", connector: "cli" },
  { id: "webhook-connector", name: "Webhook Connector", desc: "Subscribe to PremierLab events from any agent.", state: "connected", connector: "webhook" },
];

// --- New: Creative AI APIs (user-owned keys only) ---
export const CREATIVE_APIS = [
  { id: "elevenlabs-api", name: "ElevenLabs", category: "Voice", desc: "Voiceovers, audiobooks, narration, and voice cloning.", state: "pending_verification" },
  { id: "heygen", name: "HeyGen", category: "Video", desc: "Avatar videos, talking head content, spokesperson videos.", state: "not_connected" },
  { id: "higgsfield", name: "Higgsfield", category: "Video", desc: "Cinematic images, video ads, AI influencers, motion creative.", state: "not_connected" },
  { id: "runway", name: "Runway", category: "Video", desc: "Generative video, motion, and editing.", state: "not_connected" },
  { id: "pika", name: "Pika", category: "Video", desc: "Short-form generative video and animation.", state: "not_connected" },
  { id: "kling", name: "Kling", category: "Video", desc: "Realistic AI video and cinematic shots.", state: "not_connected" },
  { id: "openai-api", name: "OpenAI", category: "LLM", desc: "Writing, planning, slide outlines, content generation.", state: "connected" },
  { id: "anthropic-api", name: "Anthropic Claude", category: "LLM", desc: "Long-form writing, books, strategy, reasoning.", state: "connected" },
  { id: "gemini-api", name: "Google Gemini", category: "LLM", desc: "Visual analysis, document parsing, multimodal.", state: "connected" },
  { id: "nano-banana-api", name: "Nano Banana", category: "Image", desc: "AI image generation provider slot.", state: "needs_attention" },
  { id: "whisper-api", name: "Whisper", category: "Audio", desc: "Audio → text transcription.", state: "connected" },
];

// --- New: Storage & Publishing (user-facing) ---
export const STORAGE_PUBLISHING = [
  { id: "gdrive-s", name: "Google Drive", desc: "Asset & export storage.", state: "connected" },
  { id: "dropbox-s", name: "Dropbox", desc: "File sync & sharing.", state: "not_connected" },
  { id: "s3-s", name: "AWS S3", desc: "Object storage backbone.", state: "connected" },
  { id: "r2-s", name: "Cloudflare R2", desc: "Egress-free object storage.", state: "not_connected" },
  { id: "kdp-s", name: "KDP Export", desc: "Amazon KDP package builder.", state: "connected" },
  { id: "epub-s", name: "EPUB Export", desc: "Reflowable ebook format.", state: "error" },
  { id: "pdf-s", name: "PDF Export", desc: "Print-ready PDF pipeline.", state: "connected" },
  { id: "webhook-s", name: "Webhooks", desc: "Send PremierLab events to any URL.", state: "connected" },
];

// --- New: Marketing & CRM (user-facing) ---
export const MARKETING_CRM = [
  { id: "ghl-m", name: "GoHighLevel", desc: "All-in-one CRM and marketing platform.", state: "usage_limit_reached" },
  { id: "hubspot-m", name: "HubSpot", desc: "CRM, marketing, sales hub.", state: "not_connected" },
  { id: "stripe-m", name: "Stripe", desc: "Payments, subscriptions, billing.", state: "connected" },
  { id: "whop-m", name: "Whop", desc: "Digital product checkout.", state: "not_connected" },
  { id: "calendly-m", name: "Calendly", desc: "Meeting scheduling.", state: "not_connected" },
  { id: "zoom-m", name: "Zoom", desc: "Webinars and meetings.", state: "connected" },
  { id: "mailchimp-m", name: "Mailchimp", desc: "Email marketing automation.", state: "not_connected" },
  { id: "kit-m", name: "Kit (ConvertKit)", desc: "Creator email and newsletters.", state: "not_connected" },
  { id: "activecampaign-m", name: "ActiveCampaign", desc: "Email marketing + CRM automation.", state: "not_connected" },
];

// --- New: API keys (only masked) ---
export const SAMPLE_API_KEYS = [
  { id: "k1", name: "Production · Default", masked: "pl_live_····A6c9", type: "live", created_at: "2026-01-18", status: "active", last_used: "2 min ago" },
  { id: "k2", name: "Higgsfield · MCP", masked: "pl_mcp_····3F2", type: "mcp", created_at: "2026-01-29", status: "active", last_used: "1 hour ago" },
  { id: "k3", name: "Sandbox · Dev", masked: "pl_test_····P19", type: "test", created_at: "2026-02-01", status: "active", last_used: "Today" },
  { id: "k4", name: "Old Zapier", masked: "pl_live_····8a2", type: "live", created_at: "2025-11-04", status: "revoked", last_used: "—" },
];

export const SAMPLE_WEBHOOKS = [
  { id: "w1", name: "Project published", url: "https://hooks.example.com/pl/published", status: "verified", last_delivery: "2 min ago" },
  { id: "w2", name: "Export complete", url: "https://hooks.example.com/pl/export", status: "verified", last_delivery: "5 hours ago" },
  { id: "w3", name: "Automation failed", url: "https://hooks.example.com/pl/automation-error", status: "pending", last_delivery: "—" },
];

// --- New: Agent install prompt + MCP URL ---
export const MCP_URL = "https://mcp.premierlab.ai/v1/workspace";
export const INSTALL_PROMPT =
  "Read the PremierLab agent setup guide, connect my workspace, and ask me for any API keys you need.";

export const AGENT_PROMPT_CARDS = [
  { id: "ap1", title: "Cinematic Intro", body: "Create a 30-second cinematic intro video for my brand." },
  { id: "ap2", title: "UGC From URL", body: "Turn this product page into 5 UGC ad scripts." },
  { id: "ap3", title: "Cover + Flyer", body: "Create a book cover and matching launch flyer." },
  { id: "ap4", title: "Deck From Outline", body: "Generate a webinar slide deck from this outline." },
  { id: "ap5", title: "Influencer Pack", body: "Create an AI influencer with a fashion niche and 7 starter posts." },
  { id: "ap6", title: "Email + SMS Combo", body: "Generate a 7-email + 5-SMS launch sequence for this offer." },
];

// --- New: VideoLab + AI Influencer + Marketing Studio sample data ---
export const VIDEO_STYLES = [
  { id: "cinematic", label: "Cinematic" },
  { id: "ugc", label: "UGC" },
  { id: "explainer", label: "Explainer" },
  { id: "product", label: "Product Demo" },
  { id: "testimonial", label: "Testimonial" },
  { id: "short-ad", label: "Short Ad" },
];

export const VIDEO_FORMATS = [
  { id: "hyper", label: "Hyper Motion" },
  { id: "unboxing", label: "Unboxing" },
  { id: "ugc-f", label: "UGC" },
  { id: "demo", label: "Product Demo" },
  { id: "testimonial-f", label: "Testimonial" },
  { id: "story", label: "Story Ad" },
];

export const RECENT_VIDEOS = [
  { id: "v1", title: "Operator's Playbook · Launch Trailer", thumb: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=500&q=80", meta: "0:42 · 4K" },
  { id: "v2", title: "Cashflow Code Promo", thumb: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=500&q=80", meta: "0:30 · 1080p" },
  { id: "v3", title: "Webinar Hook · Day 1", thumb: "https://images.unsplash.com/photo-1542744095-291d1f67b221?w=500&q=80", meta: "0:15 · 9:16" },
  { id: "v4", title: "AI Avatar Intro", thumb: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=500&q=80", meta: "0:25 · 1080p" },
];

export const INFLUENCER_TYPES = [
  { id: "human", label: "Human" },
  { id: "fashion", label: "Fashion" },
  { id: "fitness", label: "Fitness" },
  { id: "business", label: "Business" },
  { id: "creator", label: "Creator" },
  { id: "luxury", label: "Luxury" },
  { id: "tech", label: "Tech" },
  { id: "lifestyle", label: "Lifestyle" },
];

export const SAVED_INFLUENCERS = [
  { id: "in1", name: "Aurora · Luxury", niche: "Luxury", style: "Editorial · soft light", thumb: "https://images.unsplash.com/photo-1769636929388-99eff95d3bf1?w=400&q=80" },
  { id: "in2", name: "Kai · Tech", niche: "Tech", style: "Studio · neon", thumb: "https://images.unsplash.com/photo-1762522926157-bcc04bf0b10a?w=400&q=80" },
  { id: "in3", name: "Mira · Fitness", niche: "Fitness", style: "Outdoor · vibrant", thumb: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&q=80" },
];

export const HOOKS = [
  "Pattern interrupt", "Curiosity gap", "Bold claim", "Stat shock",
  "Founder story", "Direct address", "Demo opening",
];

export const SETTINGS = [
  "Studio", "Outdoor", "Coffee shop", "Office", "Luxury hotel", "Street", "Home",
];

export const LOGO_STYLES = [
  { id: "wordmark", label: "Wordmark", desc: "Type-led brand mark." },
  { id: "monogram", label: "Monogram", desc: "Initial-driven mark." },
  { id: "icon", label: "Icon", desc: "Symbol + name." },
  { id: "emblem", label: "Emblem", desc: "Enclosed badge-style mark." },
  { id: "abstract", label: "Abstract", desc: "Geometric or modern abstract." },
  { id: "lettermark", label: "Lettermark", desc: "Single-letter precision mark." },
];

export const LOGO_PALETTES = [
  { id: "aqua", label: "Premier Aqua", hex: ["#061414", "#27E6D1", "#B9FF2F"] },
  { id: "mono", label: "Monochrome", hex: ["#0A0A0A", "#FFFFFF", "#9CA3AF"] },
  { id: "luxury", label: "Luxury Gold", hex: ["#0B0B0B", "#C9A86A", "#F5EAD0"] },
  { id: "vibrant", label: "Vibrant", hex: ["#F43F5E", "#0EA5E9", "#FACC15"] },
];

export const SAVED_LOGOS = [
  { id: "lg1", name: "PremierLab · Mark", thumb: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=400&q=80" },
  { id: "lg2", name: "Operator's Playbook", thumb: "https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=400&q=80" },
  { id: "lg3", name: "Cashflow Code", thumb: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=400&q=80" },
  { id: "lg4", name: "Quiet Empire", thumb: "https://images.unsplash.com/photo-1532012197267-da84d127e765?w=400&q=80" },
];
